import api, { ApiCallReturn } from "../api";

export const postUsersChatNotify = (params: Record<string, any>): ApiCallReturn => api.post(`/chats/users-notify`, params);
export const postUserCompetitionNotificationRival = (competitionId: number, params: Record<string, any>): ApiCallReturn => api.post(`/users/competitions/${competitionId}/notification-rival`, params);
export const postImagesCompress = (image: string): ApiCallReturn => api.post(`/images/compress`, {image});
